import { applyMasonry } from "../masonry";
import { addToWrapper, appendToWrapper, listItem } from "../dynamic_card/dynamic_card";

interface BlogItem {
  title?: string;
  subtitle?: string;
  text?: string;
  image?: string;
  link?: string;
  modal_target?: string;
  category: listItem[];
}

function initBlog(): void {
  const container = document.querySelector<HTMLElement>('.js-blog-andromeda__list');
  if (!container) return;

  const skeletonElement = container.querySelector<HTMLElement>(".js-card--skeleton");
  if (!skeletonElement) return;

  const skeleton = skeletonElement.cloneNode(true) as HTMLElement;

  const categoryFilter =
    document.querySelectorAll<HTMLElement>('.js-blog-andromeda__categories-item');

  const items: BlogItem[] = JSON.parse(
    container.dataset.dynamicItemsJson ?? '[]'
  );

  let filteredItems: BlogItem[] = items;

  skeletonElement.classList.add("hide");

  const categoryParam = getParamFromUrl("category");
  if (categoryParam && categoryParam != 0) {
    filteredItems = filterCategories(items, categoryParam);
    const filterTab = document.querySelector<HTMLElement>(`.js-blog-andromeda__categories-item[data-code="${categoryParam}"]`);
    if (filterTab)
      filterTab.classList.add('active');


    addToWrapper(
      filteredItems.slice(0, 12),
      skeleton,
      container
    );

    if (container.classList.contains("js-masonry-list")) {
      applyMasonry(container, 1);
    }
  }

  if (container.classList.contains("js-masonry-list")) {
    applyMasonry(container, 1);
  }

  categoryFilter.forEach((el: HTMLElement) => {
    el.addEventListener('click', () => {
      const categoryId = el.dataset.code;
      const visibleItems = parseInt(container.dataset.visibleItems ?? '0', 10);

      const activeCategory =
        document.querySelector<HTMLElement>(
          '.js-blog-andromeda__categories-item.active'
        );

      if (activeCategory) {
        activeCategory.classList.remove("active");
      }

      if (categoryId) {
        filteredItems = filterCategories(items, parseInt(categoryId, 10));
        el.classList.add("active");

        addToWrapper(
          filteredItems.slice(0, visibleItems),
          skeleton,
          container
        );

        if (container.classList.contains("js-masonry-list")) {
          applyMasonry(container, 1);
        }
      }
    });
  });

  // Recalcular en responsive
  if (container.classList.contains("js-masonry-list")) {
    window.addEventListener('resize', () => {
      applyMasonry(container, 1);
    });
  }

  window.addEventListener('scroll', () => {
    const scrollTop = container.getBoundingClientRect().top;
    const clientHeight = window.innerHeight;
    const scrollHeight = container.scrollHeight;
    const visibleItems = parseInt(container.dataset.visibleItems ?? '0', 10);

    if (visibleItems !== filteredItems.length) {
      if (scrollTop < 0 && scrollTop <= clientHeight - scrollHeight) {
        const sliceEnd = visibleItems + 12;
        const slicedItems = filteredItems.slice(visibleItems, sliceEnd);

        if (slicedItems.length > 0) {
          appendToWrapper(
            slicedItems,
            skeleton,
            container,
            visibleItems
          );

          if (container.classList.contains("js-masonry-list")) {
            applyMasonry(container, 1);
          }
        }
      }
    }
  });
}

/**
 * Filtro por categoría
 */
function filterCategories(items: BlogItem[], id: number): BlogItem[] {
  paramsToUrl("category", id);
  if (id == 0) {
    return items;
  }

  return items.filter(item =>
    item.category.some(category => category.id === id)
  );
}

function paramsToUrl(param: string, id?: number) {
  let url = new URL(window.location.href);
  url.searchParams.delete(param);

  if(id && id !== 0) {
    url.searchParams.append(param, id.toString());
  }
  window.history.pushState({}, '', url);
}

function getParamFromUrl(param: string) {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(param);

  if (value === null) {
    return undefined;
  }

  const parsed = Number(value);
  return isNaN(parsed) ? undefined : parsed;
}

export { initBlog };
